//
// Module for the Manual wizard's Insurance Information tab on the Benefit Details step
//
rs.module("participant/benefit/setup/manual/wizard/benefitdetailstabs/insuranceinformation",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, backendUrls) {

            // get JS selectors
            var insuranceInformationTab = $.js(jsSelectors.insuranceInformationTab);

            var healthInsuranceCard = insuranceInformationTab.js(jsSelectors.healthInsuranceCard);
            var healthCarrierSelect = healthInsuranceCard.js(jsSelectors.healthCarrierSelect);
            var healthRateTierSelect = healthInsuranceCard.js(jsSelectors.healthRateTierSelect);
            var healthRateTierSelectHelper = selectHelper.getHelper(healthRateTierSelect);
            var healthCoverageSelect = healthInsuranceCard.js(jsSelectors.healthCoverageSelect);
            var healthCoverageSelectHelper = selectHelper.getHelper(healthCoverageSelect);

            var dentalInsuranceCard = insuranceInformationTab.js(jsSelectors.dentalInsuranceCard);
            var dentalCarrierSelect = dentalInsuranceCard.js(jsSelectors.dentalCarrierSelect);
            var dentalRateTierSelect = dentalInsuranceCard.js(jsSelectors.dentalRateTierSelect);
            var dentalRateTierSelectHelper = selectHelper.getHelper(dentalRateTierSelect);
            var dentalCoverageSelect = dentalInsuranceCard.js(jsSelectors.dentalCoverageSelect);
            var dentalCoverageSelectHelper = selectHelper.getHelper(dentalCoverageSelect);

            // Customize jquery validation to conditionally apply validations
            _setupCustomValidation(jsSelectors.healthInsuranceCard);
            _setupCustomValidation(jsSelectors.dentalInsuranceCard);

            RegisterCarrierChangeEvent(healthInsuranceCard, healthCarrierSelect, healthCoverageSelect, healthCoverageSelectHelper, healthRateTierSelect, healthRateTierSelectHelper, codeValues.health);
            RegisterCarrierChangeEvent(dentalInsuranceCard, dentalCarrierSelect, dentalCoverageSelect, dentalCoverageSelectHelper, dentalRateTierSelect, dentalRateTierSelectHelper, codeValues.dental);

            // register the change event for the provided carrierSelect to populate coverageSelect and toggle validation
            function RegisterCarrierChangeEvent(insuranceCard, carrierSelect, coverageSelect, coverageSelectHelper, rateTierSelect, rateTierSelectHelper, insuranceType) {
                carrierSelect.change(function () {

                    _updateValidationScope(insuranceCard, carrierSelect.val() != "");

                    if (carrierSelect.val() == "") {
                        rateTierSelectHelper.clearOptions();
                        rateTierSelectHelper.setDisabled(true);
                    } else {
                        rateTierSelectHelper.loadOptionsFrom(
                            backendUrls.LoadInsuranceRateTierOptions,
                            {
                                insuranceType: insuranceType,
                                insuranceCarrierKey: carrierSelect.val()
                            },
                            {
                                withBlank: true
                            });

                        rateTierSelectHelper.setDisabled(false);
                    }

                    coverageSelectHelper.clearOptions();
                    coverageSelectHelper.setDisabled(true);

                    // Clear errors
                    [
                        rateTierSelect,
                        coverageSelect
                    ].forEach((input) => input.clearErrors());
                });

                rateTierSelect.change(function () {

                    _updateValidationScope(insuranceCard, rateTierSelect.val() != "");

                    if (rateTierSelect.val() == "") {
                        coverageSelectHelper.clearOptions();
                        coverageSelectHelper.setDisabled(true);
                    } else {
                        coverageSelectHelper.loadOptionsFrom(
                            backendUrls.getInsuranceCoverages,
                            {
                                insuranceType: insuranceType,
                                insuranceCarrierKey: carrierSelect.val(),
                                insuranceRateTierKey: rateTierSelect.val()
                            },
                            {
                                withBlank: true
                            });
                        coverageSelectHelper.setDisabled(false);
                    }

                    // Clear errors
                    [
                        rateTierSelect,
                        coverageSelect
                    ].forEach((input) => input.clearErrors());
                });

                coverageSelect.change(function () {

                    _updateValidationScope(insuranceCard, coverageSelect.val() != "");

                    coverageSelect.clearErrors();
                });
            }

            // Update the data-val property of provided insuranceCard so
            // the custom jquery validation "ignore" function can look at it
            function _updateValidationScope(insuranceCard, validate) {
                insuranceCard.data("val", validate);

                // Set the html attribute for data-val so css can see it
                insuranceCard.attr('data-val', validate);
            }

            // Customize jqueryvalidation to possibly skip client-side validations if
            // the validationScope is configured to not validate its children
            function _setupCustomValidation(insuranceCardSelector) {
                var currentIgnoreFunction = $.validator.defaults.ignore;

                var overrides = {
                    ignore: function (index, element) {

                        var result = false;

                        if (currentIgnoreFunction) {
                            result = currentIgnoreFunction(index, element);
                        }

                        if (!result) {

                            var validationScope = $(element).closestjs(insuranceCardSelector, { required: false });
                            if (validationScope.length > 0) {
                                result = validationScope.data("val") == false
                            }
                        }

                        return result;
                    }
                }

                // merge our overrides into the current active defaults
                $.validator.setDefaults(overrides);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);